'use client'

import { motion } from 'framer-motion'

export function AppsGridPlaceholder() {
  return (
    <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
      {Array.from({ length: 4 }).map((_, index) => (
        <motion.div
          // biome-ignore lint/suspicious/noArrayIndexKey: placeholder skeleton tiles
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5, delay: index * 0.08, ease: 'easeOut' }}
          className='relative flex flex-col gap-4 overflow-hidden rounded-2xl border border-borderPrimary bg-backgroundPrimary p-8 shadow-lg'
        >
          <span className='absolute top-5 right-5 rounded-full border border-borderPrimary bg-backgroundSecondary px-2.5 py-1 font-mono text-contentTertiary text-xs uppercase tracking-widest'>
            Wkrótce
          </span>
          <div className='size-12 animate-shimmer-pulse rounded-xl bg-backgroundHoverOverlay' />
          <div className='h-6 w-48 animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
          <div className='h-4 w-full animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
          <div className='h-4 w-3/4 animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
        </motion.div>
      ))}
    </div>
  )
}
